// extracted by mini-css-extract-plugin
export var currencyInput = "_mg-1";
export var currencySymbol = "_mg-0";